import React from "react";
import { Wheel } from "react-custom-roulette";
import { WheelContainer, OuterBadge, CenterIcon } from "../SpinHome.style";
import { IMG_ARROW, IMG_CENTER } from "@assets";

const textColors = [
	"#342309",
];
const backgroundColors = [
	"#fffcf3",
	"#fd1615"
];

const borderRadius = '30px'; // Adjust the border radius as desired

const backgroundStyles = backgroundColors.map((bgColor) => ({
  background: `${bgColor}, ${borderRadius}`,
}));

const pointerProps = { src: IMG_ARROW };

const props = {
	textColors,
	backgroundColors,
	pointerProps,
	fontFamily: "Libre Franklin",
	fontWeight: "bold",
	fontSize: 16,
	radiusLineWidth: 0,
	outerBorderWidth: 0,
	innerBorderColor: "#FFA500",
	innerBorderWidth: 6,
	innerRadius: 0,
	textDistance: 70,
};

const SpinWheel = ({
	handleSpinClicked,
	started,
	winningIndex,
	spinValues,
	handleStop,
}) => {
	return (
		<WheelContainer>
			<OuterBadge onClick={handleSpinClicked} />
			<Wheel
				disableInitialAnimation={true}
				mustStartSpinning={started}
				prizeNumber={winningIndex}
				backgroundStyles={backgroundStyles}
				data={spinValues}
				onStopSpinning={handleStop}
				{...props}
			/>
			<CenterIcon id="center" src={IMG_CENTER} />
		</WheelContainer>
	);
};

export default SpinWheel;
